<template>
  <el-dialog title="调岗申请" :close-on-click-modal="false" :visible.sync="show" center @close="$emit('close')" width="520px">
    <el-form ref="ruleForm" label-width="180px" class="ruleForm">
      <el-form-item label="调岗人员：">
        <el-select filterable placeholder="请选择调岗人员" size="medium" style="width:240px" clearable>
          <el-option label="item.Title" value="item.Name" />
        </el-select>
      </el-form-item>
      <el-form-item label="当前岗位：">
        <el-input size="medium" style="width:240px" clearable readonly />
      </el-form-item>
      <el-form-item label="调岗岗位：">
        <el-select filterable placeholder="请选择调岗岗位" size="medium" style="width:240px" clearable>
          <el-option label="item.Title" value="item.Name" />
        </el-select>
      </el-form-item>
      <el-form-item label="生效起止日期：">
        <el-date-picker style="width:240px" size="medium" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" type="daterange" range-separator="-" start-placeholder="生效起期" end-placeholder="生效止期" clearable />
      </el-form-item>
      <el-form-item>
        <div class="submitBtn">
          <el-button size="medium" class="cancelWireless" @click="$emit('close')">取消</el-button>
          <el-button size="medium" type="primary" :loading='submitLoad' @click="submit">提交</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  name: "JobMobilityDialog",
  props: ['show'],
  data() {
    return {
      submitLoad: false,
      CommissionLevel: this.$CommissionLevel
    }
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {

        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.ruleForm {
  padding: 16px 0;
  .submitBtn {
    display: flex;
    :deep(.el-button) {
      width: 92px;
    }
    :deep(.el-button + .el-button) {
      margin-left: 16px;
    }
  }
}
</style>